import { motion } from "framer-motion";
import { MapPin, Home } from "lucide-react";
import { PRACTICE, IMAGES } from "@/data/practice";

export const Coverage = () => {
  return (
    <section
      id="zone"
      data-testid="coverage-section"
      className="py-20 sm:py-28 bg-[#2C362B] relative overflow-hidden"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#9FD6CC] mb-4">
            Zone d'intervention
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#FAF9F6] leading-tight">
            Nous intervenons au cœur de Bordeaux
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#C9CFC6] leading-relaxed max-w-lg">
            Nous nous déplaçons à votre domicile dans les quartiers historiques de
            la rive gauche. Vous pouvez aussi être reçu au cabinet, sur rendez-vous.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {PRACTICE.zones.map((z) => (
              <span
                key={z}
                data-testid={`zone-${z}`}
                className="inline-flex items-center gap-2 bg-white/10 backdrop-blur border border-white/15 rounded-full px-5 py-2.5 text-[#FAF9F6] font-medium"
              >
                <MapPin className="w-4 h-4 text-[#9FD6CC]" strokeWidth={1.75} />
                {z}
              </span>
            ))}
          </div>

          <div className="mt-10 flex items-center gap-3 text-[#C9CFC6]">
            <Home className="w-5 h-5 text-[#9FD6CC]" strokeWidth={1.75} />
            <span>{PRACTICE.address}</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="rounded-[2rem] overflow-hidden shadow-2xl aspect-[4/3]">
            <img
              src={IMAGES.bordeaux}
              alt="Flèche Saint-Michel de Bordeaux, quartier d'intervention du cabinet infirmier"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
